import React, { useState } from 'react';
import { Alert, Button, Card, CardActions, CardContent, CardHeader, Typography } from '@mui/material';
import Looks3Icon from '@mui/icons-material/Looks3';
import { DropzoneDialog } from 'mui-file-dropzone';
import { ProductPageDocumentsState } from 'modules/aftermarket';
import { DocumentsList } from './DocumentsList';

interface Props {
  canWrite: boolean;
  documents: ProductPageDocumentsState;
  setDocuments: (documents: ProductPageDocumentsState) => void;
}

export const DocumentsCard = ({ canWrite, documents, setDocuments }: Props) => {
  const [isDropzoneDialogOpen, setIsDropzoneDialogOpen] = useState<boolean>(false);

  const handleSaveFiles = (files: File[]) => {
    setDocuments({ ...documents, documentsToAdd: [...documents.documentsToAdd, ...files] });
    setIsDropzoneDialogOpen(false);
  };

  return (
    <>
      <Card variant="outlined" sx={{ padding: '1rem' }}>
        <CardHeader
          sx={{ padding: 0 }}
          title={
            <Typography variant="subtitle1" color="primary">
              <Looks3Icon /> Product Attachments
            </Typography>
          }
        />
        <CardContent>
          {documents.initialDocuments.length === 0 && documents.documentsToAdd.length === 0 ? (
            <Alert severity="info">No Attachments</Alert>
          ) : (
            <DocumentsList canWrite={canWrite} documents={documents} setDocuments={setDocuments} />
          )}
        </CardContent>
        <CardActions>
          <Button variant="contained" disabled={!canWrite} onClick={() => setIsDropzoneDialogOpen(true)} size="small">
            Attach Document
          </Button>
        </CardActions>
      </Card>

      <DropzoneDialog
        acceptedFiles={['application/pdf']}
        cancelButtonText={'cancel'}
        submitButtonText={'submit'}
        open={isDropzoneDialogOpen}
        onClose={() => setIsDropzoneDialogOpen(false)}
        onSave={handleSaveFiles}
        fileObjects={[]}
      />
    </>
  );
};
